import {createSlice} from '@reduxjs/toolkit';
import {getUserShortInfoSuccess} from 'src/openapi/admin/apis/GetUserShortInfoApi';
import {
    getUserAuthenticationInfoFailure,
    getUserAuthenticationInfoSuccess,
} from 'src/openapi/admin/apis/UserAuthenticationInfoApi';

import type {UserAuthInfoResponse} from 'src/openapi/admin/models/UserAuthInfoResponse';
import type {UserShortInfo} from 'src/openapi/admin/models/UserShortInfo';
import type {AppState} from 'src/store/typedef';
import type {ServerResponse} from 'src/typedef';

type UserDetails = {
    shortInfo: UserShortInfo | null,
    isAccountManager: boolean,
    authInfo: ServerResponse<UserAuthInfoResponse> | null,

};

const initialState: UserDetails = {
    shortInfo: null,
    isAccountManager: false,
    authInfo: null,
};

export const userPageSlice = createSlice({
    name: 'userPage',
    initialState,
    reducers: {
        clearUserPage: state => {
            state.shortInfo = null;
            state.isAccountManager = false;
            state.authInfo = null;
        },
        setIsAccountManager: (state, action) => {
            state.isAccountManager = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getUserShortInfoSuccess, (state, action) => {
                state.shortInfo = action.payload.data;
            })
            .addCase(getUserAuthenticationInfoSuccess, (state, action) => {
                state.authInfo = {data: action.payload.data};
            })
            .addCase(getUserAuthenticationInfoFailure, (state, action) => {
                state.authInfo = {error: action.payload.data};
            });
    },
});

export const {clearUserPage, setIsAccountManager} = userPageSlice.actions;

export type SelectUserDetails = (state: AppState) => UserDetails;
export const selectUserDetails: SelectUserDetails = state => state.userPage.details;
